import "./SingleServiceTemplate.module.css"
import Header from "@/reusable_sections/Header"
import SingleServiceTemplateSection from "./sections/SingleServiceTemplateSection"
import Footer from "@/reusable_sections/Footer"

export default function SingleServiceTemplatePage() {

  return (
    <div>
      <Header />
      <SingleServiceTemplateSection />
      <Footer />
    </div>
  )
}
